// Side-effect import: the care-finder module calls initMasonryRegistry() at
// load time. Without this, care_finder renderers (e.g. schedulingCard) are
// not registered until the user navigates to the lazy-loaded care-finder route.
import '@leagueplatform/care-finder';
import React from 'react';
import { driver } from '@leagueplatform/masonry';
import { DEFAULT_NAMESPACE } from '@leagueplatform/masonry-engine';

// The masonry pageHeader node type renders PageHeader (a plain heading component
// with no background class), so the transparent-header hook and CSS noise/gradient
// styles never activate. This wrapper adds cc-page-header-background so both work.
export const initMasonryRegistry = () => {
  const DefaultPageHeaderRenderer =
    driver.nodeRendererRegistry.nodeRenderers[DEFAULT_NAMESPACE].pageHeader;

  driver.nodeRendererRegistry.overrideRenderer(
    'pageHeader',
    DEFAULT_NAMESPACE,
    (props) =>
      React.createElement(DefaultPageHeaderRenderer, {
        ...props,
        className: `cc-page-header-background${
          props.className ? ` ${props.className}` : ''
        }`,
      }),
  );
};
